"use client";

import { Mail, Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function ContactDetails() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  return <section id="contactdetails" ref={sectionRef} className="relative py-12 px-4 sm:px-6 lg:px-8 bg-background">
      <div className="max-w-4xl mx-auto">
        <div className={`glass-effect p-8 transition-all duration-[var(--duration-medium)] ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
              Get in Touch
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              You can reach us directly using the contact details below, or fill
              out the contact form to send us a message. We look forward to
              hearing from you!
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mt-8">
            <div className={`flex items-start gap-4 p-6 rounded-lg bg-primary-light border border-border transition-all duration-[var(--duration-medium)] delay-100 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary-light flex items-center justify-center">
                <Phone className="w-6 h-6 text-foreground" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-foreground mb-2">
                  Phone
                </h3>
                <Link to="tel:+447355792647" className="text-primary hover:text-primary-hover transition-colors duration-[var(--duration-fast)]">
                  +44 7355 792647
                </Link>
              </div>
            </div>

            <div className={`flex items-start gap-4 p-6 rounded-lg bg-secondary-light border border-border transition-all duration-[var(--duration-medium)] delay-200 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-secondary flex items-center justify-center">
                <Mail className="w-6 h-6 text-foreground-secondary" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-foreground mb-2">
                  Email
                </h3>
                <Link to="mailto:support@educationfamilytutors.com" className="text-foreground hover:text-foreground transition-colors duration-[var(--duration-fast)] break-all">
                  support@educationfamilytutors.com
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}